/**
 * Header bar for the Medical Necessity Analysis page.
 *
 * Displays the page title, patient identity tags (name / id / ICD code),
 * and a close button that dismisses the screen.
 * @module MedicalNecessityAnalysisHeader
 */
import { Tags } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import { CrossIcon } from "../../../svg/cross-icon";

export interface MedicalNecessityAnalysisHeaderProps {
  onClose: () => void;
  patientName: string;
  patientId: string;
  icdCode?: string;
  /** Regimen name from the order regimen/ICD endpoint (`regimen_name`). */
  regimenName?: string;
}

const MedicalNecessityAnalysisHeader: React.FC<
  MedicalNecessityAnalysisHeaderProps
> = ({ onClose, patientName, patientId, icdCode, regimenName }) => (
  <div className="medical-necessity-analysis--header flex h-[3.75rem] shrink-0 flex-row items-center justify-between border-b border-primaryGray-15 px-4 py-3">
    <div className="flex items-center gap-2.5">
      <div className="text-[14px] font-bold leading-[22px] text-primaryGray-1">
        Medical Necessity Analysis
      </div>
      {patientName && (
        <Tags
          label={patientName}
          backgroundColor="#F5F5F5"
          textColor="#0F0F0F"
          className="!m-0 shrink-0"
        />
      )}
      {patientId && patientId !== "—" && (
        <Tags
          label={patientId}
          backgroundColor="#FFFCD6"
          textColor="#665D00"
          className="!m-0 shrink-0"
        />
      )}
      {icdCode && (
        <Tags
          label={`ICD ${icdCode}`}
          backgroundColor="#E6F3F0"
          textColor="#005D49"
          className="!m-0 shrink-0"
        />
      )}
      {regimenName && (
        <Tags
          label={regimenName}
          backgroundColor="#EEE9FF"
          textColor="#4B32B3"
          className="!m-0 shrink-0"
        />
      )}
    </div>
    <button
      type="button"
      onClick={onClose}
      className="flex items-center justify-center"
      aria-label="Close"
    >
      <CrossIcon width="20" height="20" fillColor="#3D3D3D" />
    </button>
  </div>
);

export default MedicalNecessityAnalysisHeader;
export { MedicalNecessityAnalysisHeader };
